import React, { Fragment } from "react";
import { Route } from "react-router";
import {
  FeedbackController,
  LibraryContainer,
  SignInController,
  UserDataController,
  QuizController,
  ForgotPasswordController,
} from "./Containers";
import {LoginController} from "./Containers/LoginV2/Login.controller";

export type PathRoutesType =
  | "/login"
  | "/signup"
  | "/feedback"
  | "/quiz"
  | "/"
  | "/forgot-password";

const RoutesNavigation: React.FC<{
  path: PathRoutesType;
  controller: React.FC;
}> = ({ path, controller }) => <Route path={path} component={controller} />;

function Router() {
  return (
    <Fragment>
      <RoutesNavigation path="/login" controller={LoginController} />
      <RoutesNavigation path="/signup" controller={UserDataController} />
      <RoutesNavigation path="/feedback" controller={FeedbackController} />
      <RoutesNavigation path="/quiz" controller={QuizController} />
        {/*<RoutesNavigation path="/" controller={LoginController} />*/}
      <RoutesNavigation
        path="/forgot-password"
        controller={ForgotPasswordController}
      />

      {/* <Route path="/login" component={SignInController} /> */}
      {/* <Route path="/radio" component={LibraryContainer}>
        
      </Route>
      <Route path="/library">
        <LibraryContainer />
      </Route>

      <Route path="/tooltip" component={LibraryContainer} />

      <Route path="/buttons" component={LibraryContainer} />

      <Route path="/inputs" component={LibraryContainer} />

      <Route path="/snackbar" component={LibraryContainer} />
        
      <Route path="/modals" component={LibraryContainer} /> */}
    </Fragment>
  );
}

export default Router;
